import React from 'react';
import { Box } from '@mui/material';

/**
 * The phone's segmented control, for a dashboard whose sections sit side by side
 * on desktop: a phone has room for one, so this picks it.
 */
function PhoneSegments<Key extends string>({
  value,
  options,
  onChange
}: {
  value: Key;
  options: { key: Key; label: string }[];
  onChange: (next: Key) => void;
}): React.ReactElement {
  return (
    // Sticks under the header while the list scrolls, like a native tab strip.
    // -16px: sticky offsets count from inside the scroll area's 16px padding.
    <Box sx={{ position: 'sticky', top: '-16px', zIndex: 3, mx: '-16px', px: '16px', py: '8px', bgcolor: '#0F0F0F' }}>
      <Box
        role="tablist"
        sx={{
          display: 'flex',
          p: '3px',
          gap: '3px',
          bgcolor: '#1A1A1A',
          border: '1px solid #2A2A2A',
          borderRadius: '10px'
        }}
      >
        {options.map((option) => {
          const on = option.key === value;
          return (
            <Box
              key={option.key}
              component="button"
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => onChange(option.key)}
              sx={{
                flex: 1,
                minWidth: 0,
                height: 38,
                px: '6px',
                borderRadius: '8px',
                border: `1px solid ${on ? 'rgba(247, 148, 32, 0.45)' : 'transparent'}`,
                bgcolor: on ? 'rgba(247, 148, 32, 0.12)' : 'transparent',
                color: on ? '#FDFDFD' : '#868686',
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                cursor: 'pointer',
                transition: 'background-color 0.15s, color 0.15s, border-color 0.15s'
              }}
            >
              {option.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default PhoneSegments;
